import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { ChartData } from "../../../types/metrics";

interface ChartProps {
  data: ChartData[];
  title: string;
}

const Chart: React.FC<ChartProps> = ({ data, title }) => (
  <ResponsiveContainer width="100%" height={300}>
    <LineChart data={data}>
      <CartesianGrid stroke="#ccc" />
      <XAxis dataKey="label" />
      <YAxis />
      <Tooltip />
      <Line type="monotone" dataKey="value" stroke="#2196f3" />
    </LineChart>
  </ResponsiveContainer>
);

export default Chart;
